document.addEventListener('DOMContentLoaded', function() {
    document.dispatchEvent(new Event('lefPrepareAllToBeLoadedPopups'));
});

document.addEventListener("lefPrepareAllToBeLoadedPopups", function () {
    const popup_links = document.querySelectorAll('a[href^="#lef-load-in-popup-"]');

    if (popup_links) {
        popup_links.forEach(link => {
            const href = link.getAttribute('href');
            const match = href.match(/^#lef-load-in-popup-(.+)$/);
            if (match) {
                const popup_id = match[1];

                link.addEventListener('click', (event => {
                    var link_href = link.getAttribute('href');
                    if (!link_href.includes('lef-load-in-popup') || link.hasAttribute('disabled')) {
                        return;
                    }

                    if (document.querySelector('.lef-popup[data-popup-id="lef-popup-' + popup_id + '"]')) {
                        link.setAttribute('href', '#lef-popup-' + popup_id);
                        return;
                    }

                    link.setAttribute('disabled', 'disabled');

                    var ajax_data = new URLSearchParams({
                        action: 'lef_load_popup_via_ajax',
                        post_id: popup_id
                    });
                    
                    fetch(theme_object.ajax_url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: ajax_data,
                        timeout: 1000 // Note: `fetch` does not support timeout natively
                    })
                    .then(response => response.text())
                    .then(data => {
                        data = JSON.parse(data);

                        if (data.success != undefined && data.success == true) {
                            if (data.popup_html != undefined && data.popup_html != '') {
                                var footer = document.querySelector('footer');
                                footer.insertAdjacentHTML('afterend', data.popup_html);
                                document.dispatchEvent(new Event('lefLoadAllComponents'));

                                var new_popup = document.querySelector('.lef-popup[data-popup-id="lef-popup-' + popup_id + '"]');
                                if (new_popup) {
                                    new_popup.classList.add('popup-opened');
                                    link.setAttribute('href', '#lef-popup-' + popup_id);
                                }
                                link.removeAttribute('disabled');
                            }
                        } else {
                            if (data.message != undefined && data.message != '') {
                                alert(data.message);
                            }
                        }
                    })
                    .catch(error => {
                    });
                    

                }), {once : true});
            }
        });
    }
});